import React from 'react'
import { JsonIntoUl } from 'components/json-into-ul'

const SAMPLE_JSON = JSON.stringify({
  company: 'Acme Corp',
  revenue: '$2.4M',
  employees: 120,
  tags: ['Enterprise', 'Food & Bev'],
})

export function JsonIntoUlMock(): React.ReactElement {
  return (
    <div className="text-sm">
      <JsonIntoUl value={SAMPLE_JSON} fallback={<span>—</span>} />
    </div>
  )
}
